/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `AGENT` - AGENT * `ANALYST` - ANALYST * `BACKGROUNDER` - BACKGROUNDER * `BREEDER` - BREEDER * `BUTCHER` - BUTCHER * `CONSULTANT` - CONSULTANT * `COMMISSION_BUYER` - COMMISSION_BUYER * `FEEDLOT` - FEEDLOT * `HOBBY_FARMER` - HOBBY_FARMER * `LIVE_EXPORTER` - LIVE_EXPORTER * `PROCESSOR` - PROCESSOR * `STUD` - STUD * `TRADER` - TRADER
 * @export
 * @enum {string}
 */
export enum TypesEnum {
    Agent = 'AGENT',
    Analyst = 'ANALYST',
    Backgrounder = 'BACKGROUNDER',
    Breeder = 'BREEDER',
    Butcher = 'BUTCHER',
    Consultant = 'CONSULTANT',
    CommissionBuyer = 'COMMISSION_BUYER',
    Feedlot = 'FEEDLOT',
    HobbyFarmer = 'HOBBY_FARMER',
    LiveExporter = 'LIVE_EXPORTER',
    Processor = 'PROCESSOR',
    Stud = 'STUD',
    Trader = 'TRADER'
}



